import { ArrowRight, ArrowLeft } from "lucide-react";
import { Section, YesNo } from "./ui";

export function SiteStep({ site, setSite, onContinue, onBack }) {
  const blocked = site.rear_access === "blocked";
  return (
    <Section title="Site & logistics" eyebrow="Step 4 · Site">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 max-w-4xl">
        <div>
          <YesNo testid="site-living" label="Will you live in the property during the build?" value={site.living_during?"yes":"no"} onChange={v=>setSite({...site,living_during:v==="yes"})}/>
          <YesNo testid="site-parking" label="Road parking for up to 3 vans?" value={site.parking_3vans?"yes":"no"} onChange={v=>setSite({...site,parking_3vans:v==="yes"})}/>
          <YesNo testid="site-permit" label="Is parking permit-only? (You arrange permits)" value={site.permit_parking?"yes":"no"} onChange={v=>setSite({...site,permit_parking:v==="yes"})}/>
          <YesNo testid="site-ulez" label="Is the property in a ULEZ zone?" value={site.ulez?"yes":"no"} onChange={v=>setSite({...site,ulez:v==="yes"})}/>
          <YesNo testid="site-driveway" label="Is there a driveway?" value={site.no_driveway?"no":"yes"} onChange={v=>setSite({...site,no_driveway:v==="no"})}/>
        </div>
        <div>
          <div className="border-b border-[#E5E7EB] py-4">
            <div className="text-sm md:text-base mb-3">Rear access width</div>
            <div className="flex flex-wrap gap-2">
              {[["wide","Suitable for a digger"],["narrow","700–1000mm"],["blocked","Under 700mm / no access"]].map(([v,l])=>(
                <button key={v} data-testid={`site-access-${v}`} onClick={()=>setSite({...site,rear_access:v})}
                  className={`px-3 py-2 text-xs font-bold uppercase tracking-wider border ${site.rear_access===v?"bg-[#12263A] text-white border-[#12263A]":"border-[#E5E7EB] bg-white"}`}>{l}</button>
              ))}
            </div>
            {blocked && (
              <p className="text-xs text-[#B45309] mt-3 font-medium" data-testid="site-access-note">We can't book this project online — our digger needs rear access to your garden. Please send us an enquiry and we'll talk through the options with you.</p>
            )}
          </div>
          <YesNo testid="site-demolish" label="Demolish an existing extension first?" value={site.demolish?"yes":"no"} onChange={v=>setSite({...site,demolish:v==="yes"})}/>
          {site.demolish && (
            <div className="py-3 flex items-center gap-3"><span className="text-xs uppercase">Approx sqm</span>
              <input data-testid="site-demolish-sqm" type="number" value={site.demolish_sqm} onChange={e=>setSite({...site,demolish_sqm:parseFloat(e.target.value)||0})} className="w-24 border border-[#E5E7EB] px-2 py-1"/>
            </div>
          )}
          <YesNo testid="site-buildover" label="Build Over Agreement likely required? (+£250 estimate)" value={site.build_over?"yes":"no"} onChange={v=>setSite({...site,build_over:v==="yes"})}/>
          <div className="text-xs text-[#6B7280] -mt-2 pb-3 leading-relaxed">
            If your extension is built over or within 3m of a public sewer or drain, your water authority requires a <b>Build Over Agreement</b> before work starts. We submit the application on your behalf — the +£250 covers our admin and the authority's fee.
          </div>
        </div>
      </div>
      <div className="mt-10 p-6 bg-[#F4F4F4] border border-[#E5E7EB] max-w-3xl">
        <div className="label-eyebrow mb-2">Party Wall — your responsibility</div>
        <p className="text-sm text-[#6B7280]">If your build is on, against or near a shared wall, you may need to serve notice under the Party Wall etc. Act 1996. Reaching agreement with your neighbours is your legal responsibility. See our FAQ for details.</p>
      </div>
      <div className="mt-10 flex gap-3">
        <button data-testid="site-back" className="de-btn-secondary" onClick={onBack}><ArrowLeft size={16}/> Back</button>
        <button data-testid="site-continue" className="de-btn-primary" onClick={()=>onContinue(blocked)}>{blocked?"Send enquiry":"Continue"} <ArrowRight size={16}/></button>
      </div>
    </Section>
  );
}
